import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmuckhohangAction } from 'src/actions/newdanhmuckhohang.action';

import CreateEditDialogNewdanhmuckhohang from '../newdanhmuckhohang-detail/CreateEditDialog';

const CreateEditDialogDieuChuyen = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.newdanhmucsanpham)
    const { info, permissions, role } = useSelector(state => state.profile)
    const [ma, setMa] = useState("")
    const [ten, setTen] = useState("")
    const [loai_san_pham, setLoaiSanPham] = useState("xe")
    const [gia_nhap, setGiaNhap] = useState("0")
    const [gia_thuc_nhap_si_1, setGiaThucNhapSi1] = useState("0")
    const [gia_thuc_nhap_si_2, setGiaThucNhapSi2] = useState("0")
    const [gia_thuc_nhap_si_3, setGiaThucNhapSi3] = useState("0")
    const [giaxuat1, setGiaXuat1] = useState("0")
    const [giaxuat2, setGiaXuat2] = useState("0")
    const [giaxuat3, setGiaXuat3] = useState("0")
    const [chiet_khau_1, setChietKhau1] = useState("0")
    const [chiet_khau_2, setChietKhau2] = useState("0")
    const [chiet_khau_3, setChietKhau3] = useState("0")

    const [khohang_id, setKhohangId] = useState("-99");
    const [khohang_name, setKhohangName] = useState("");
    const [khohang_select, setKhohangSelect] = useState(undefined);
    const [khohangList, setKhohangList] = useState([]);

    const additionalOptionKhohang = { 'id': '-99', 'ma': 'Kho hàng...', 'ten': '' };

    const [openNewdanhmuckhohang, setOpenNewdanhmuckhohang] = useState(false);

    //==========

    const handleClickOpenNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(true);
    };

    const handleCloseNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(false);
        fetchData();
    };

    //==========

    const fetchData = async() => {
        const _khohangList = await dispatch(NewdanhmuckhohangAction.khohangList());
        if (_khohangList && typeof _khohangList.data !== 'undefined' && typeof _khohangList.data.values !== 'undefined') setKhohangList(_khohangList.data.values);
    }

    useEffect(() => {
        if (props.open == true) {
            fetchData();

            resetState();

            if (props.type == 'EDIT' && selected) {
                setMa(selected.ma)
                setTen(selected.ten)
                setLoaiSanPham(selected.loai_san_pham)
                setGiaNhap(Number(selected.gia_nhap))
                setGiaThucNhapSi1(Number(selected.gia_thuc_nhap_si_1))
                setGiaThucNhapSi2(Number(selected.gia_thuc_nhap_si_2))
                setGiaThucNhapSi3(Number(selected.gia_thuc_nhap_si_3))
                setGiaXuat1(Number(selected.giaxuat1))
                setGiaXuat2(Number(selected.giaxuat2))
                setGiaXuat3(Number(selected.giaxuat3))
                setChietKhau1(Number(selected.chiet_khau_1))
                setChietKhau2(Number(selected.chiet_khau_2))
                setChietKhau3(Number(selected.chiet_khau_3))

                if (typeof selected.newdanhmuckhohang_ref !== 'undefined' && selected.newdanhmuckhohang_ref) {
                    const newValue = selected.newdanhmuckhohang_ref;

                    const khohangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                
                    const html = `
                        <div>
                            ${khohangLine}
                        </div>
                    `;
                    
                    setKhohangId(selected.newdanhmuckhohang_ref.id);
                    setKhohangName(html);
                    setKhohangSelect(selected.newdanhmuckhohang_ref);
                }
            }
        }
    }, [props])

    const onPressPositive = () => {
        if (props.type === 'EDIT') {
            dispatch(NewquanlytonkhoAction.dieuChuyen({ 
                so_khung: props?.so_khung, 
                so_may: props?.so_may, 
                khohang: khohang_id,
            }))
        } else {
            // 
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setMa("")
        setTen("")
        setLoaiSanPham("xe")
        setGiaNhap("0")
        setGiaThucNhapSi1("0")
        setGiaThucNhapSi2("0")
        setGiaThucNhapSi3("0")
        setChietKhau1("0")
        setChietKhau2("0")
        setChietKhau3("0")
        setGiaXuat1("0")
        setGiaXuat2("0")
        setGiaXuat3("0")
        setKhohangId("-99");
        setKhohangName("");
        setKhohangSelect(undefined);
        setKhohangList([]);
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>Điều chuyển kho cho xe có số khung - số máy là: <span style={{color: 'green'}}>{props?.so_khung}</span> - <span style={{color: 'green'}}>{props?.so_may}</span></DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                            <Button
                                className="fast-action-btn"
                                color="primary"
                                variant="contained"
                                onClick={() => handleClickOpenNewdanhmuckhohang()}
                                style={{ 
                                    backgroundColor: 'orange',
                                }}
                            >
                                +
                            </Button>
                            <Select
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 56,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={[additionalOptionKhohang, ...khohangList]} // Thêm vào đầu danh sách
                                getOptionLabel={(item) =>
                                    `${item.ma + (item.ten ? (' - ' + item.ten) : '') + (typeof item.newdanhmuckhohang_ref !== 'undefined' ? (' (' + item.newdanhmuckhohang_ref.ma + ' - ' + item.newdanhmuckhohang_ref.ten + ')') : '')}`
                                }
                                formatOptionLabel={(item, { context }) => {
                                    const khohangLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                    return (
                                        <div>
                                            <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{khohangLine}</div>
                                        </div>
                                    );
                                }}
                                placeholder={
                                    khohang_id !== "-99"
                                        ? <span dangerouslySetInnerHTML={{ __html: khohang_name }} />
                                        : <span style={{fontWeight: 'bold'}}>Kho hàng...</span>
                                }
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={khohang_id || null}
                                onChange={(newValue) => {
                                    const khohangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                
                                    const html = `
                                        <div>
                                            ${khohangLine}
                                        </div>
                                    `;
                                
                                    setKhohangId(newValue.id);
                                    setKhohangName(html);
                                    setKhohangSelect(newValue);
                                }}
                                isSearchable
                            />
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>Đồng ý</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmuckhohang open={openNewdanhmuckhohang} handleClose={handleCloseNewdanhmuckhohang} type={"CREATE"} creatingFromAway={true} />
        </Dialog >
    );
}

export default CreateEditDialogDieuChuyen;